import { TextStyle } from 'react-native';

export const Typography: Record<string, TextStyle> = {
  display: {
    fontSize: 32,
    lineHeight: 38,
    fontWeight: '700',
    letterSpacing: 0.2,
  },
  headline: {
    fontSize: 24,
    lineHeight: 32,
    fontWeight: '700',
  },
  title1: {
    fontSize: 20,
    lineHeight: 28,
    fontWeight: '600',
  },
  title2: {
    fontSize: 18,
    lineHeight: 26,
    fontWeight: '600',
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '400',
  },
  bodySmall: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '400',
  },
  caption: {
    fontSize: 12,
    lineHeight: 16,
    fontWeight: '500',
    letterSpacing: 0.1,
  },
};

export type TypographyToken = keyof typeof Typography;
